import { numberMoney } from 'Data/format.js'

export function getTotalDiscount(payor_discounts, payment_plan_discount) {
  return numberMoney(payor_discounts + payment_plan_discount)
}
